import React, { useEffect, useRef } from 'react';
import QRCodeStyling from 'qr-code-styling';
import '../styles/DownloadApp.css';

const LOS_APP_LINK = 'https://los-prod.dailype.in/app/link';

const DownloadApp = () => {
  const qrRef = useRef(null);

  useEffect(() => {
    if (typeof window !== 'undefined' && qrRef.current) {
      const qrCode = new QRCodeStyling({
        width: 280,
        height: 280,
        type: 'svg',
        data: LOS_APP_LINK,
        image: '/images/logo2.png',
        dotsOptions: {
          color: '#295BEE',
          type: 'rounded',
        },
        backgroundOptions: {
          color: '#ffffff',
        },
        imageOptions: {
          crossOrigin: 'anonymous',
          margin: 4,
          imageSize: 0.35,
          hideBackgroundDots: true,
        },
        cornersSquareOptions: {
          color: '#295BEE',
          type: 'dot',
        },
        cornersDotOptions: {
          color: '#295BEE',
          type: 'dot',
        },
        qrOptions: {
          errorCorrectionLevel: 'H',
        },
      });

      qrRef.current.innerHTML = '';
      qrCode.append(qrRef.current);
    }
  }, []);

  return (
    <div id="download">
      <div className="download-bg-wrapper">
        <img
          src="/images/cp-subtract.svg"
          alt="Background"
          className="download-bg-img"
        />
      </div>
      <div className="download-content">
        <div className="download-info">
          <h2 className="download-title">Scan to download the app now</h2>
          <div className="download-rating">
            <div className="download-rating-item">
              <span className="download-star">★</span>
              <span className="download-rating-text">4.7 Ratings on Playstore</span>
            </div>
            <span className="download-bullet">•</span>
            <div className="download-downloads-item">
              <span className="download-downloads-text">50K+ Downloads</span>
            </div>
          </div>
          <a
            href={LOS_APP_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="download-btn-link"
          >
            <button type="button" className="download-btn">
              <img
                src="/icons/playstore.svg"
                alt="playstore"
                className="download-btn-icon"
              />
              <span>Download App Now</span>
            </button>
          </a>
        </div>
        <div className="download-qr-wrapper">
          <div className="download-qr-glow" />
          <a
            href={LOS_APP_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="download-qr-card"
            title="Scan or click to open app link"
            aria-label="Scan or click to open app link"
          >
            <div ref={qrRef} className="download-qr-canvas-wrapper" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default DownloadApp;
